export const environment = {
  name: 'staging-prod-tenant',
  production: true,
  auth0: {
    domain: 'auth.tbmaestro.com',
    clientId: 'ynmxMRT4ICQXO8xqBLUYJTaje1PGn33U',
    audience: 'api.staging.tbmaestro.net'
  },
  backend: {
    baseUrl: 'https://backendstaging.tbmaestro.net',
    websocketUrl: 'wss://backendstaging.tbmaestro.net',
    graphql: {
      endpoint: '/graphql',
    }
  },
  userGuide: {
    baseUrl: 'https://gaia.tbmaestro.ca',
    apiKey: 's9kZrIMcyT7dipJZaN0fhhXtZUnForFFFP0huGPXk6T9eg8KKEhOQ3K5ZWoo-MgV'
  },
  profile: {
    accountsPortal: 'https://accounts.tbmaestro.com'
  },
  scripts: {
    jmapUrl: 'https://backendstaging.tbmaestro.net/jmap',
    metarealSDK: 'https://stage.metareal.com/playersdk/playersdk.min.1.0.js'
  },
  apiKey: {
    googleMaps: 'AIzaSyCYPvVQxK48seq3RMQGKC760B3g9a4vXvM'
  },
  logRocket: {
    enabled: true,
    appId: 'avsvs0/3t-staging'
  }
};
